var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kb-files" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.files"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.selectFile } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.addFile")))]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("EmbeddingProgressPanel", {
        attrs: {
          visible: _vm.uploading || _vm.showEmbeddingBanner,
          "show-upload": _vm.uploading,
          "show-embedding": _vm.showEmbeddingBanner,
          "upload-percent": _vm.uploadProgress,
          "upload-completed": _vm.completedFiles,
          "upload-total": _vm.totalFiles,
          "embed-percent": _vm.embeddingOverlay.percent,
          "embed-completed": _vm.embeddingOverlay.completed,
          "embed-total": _vm.embeddingOverlay.total,
        },
      }),
      _vm._v(" "),
      _vm.files.length
        ? _c("div", [
            _c("div", [
              _c(
                "div",
                [
                  _c("ve-pagination", {
                    attrs: {
                      total: _vm.total,
                      "page-index": _vm.page,
                      "page-size": _vm.pageSize,
                      "page-size-option": [1, 10, 15, 20, 50, 100],
                    },
                    on: {
                      "on-page-number-change": function (val) {
                        return (_vm.page = val)
                      },
                      "on-page-size-change": function (val) {
                        return (_vm.pageSize = val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "files" },
                _vm._l(_vm.files, function (kb) {
                  return _c("div", { key: kb._id, staticClass: "file" }, [
                    _vm.isSupsisRag
                      ? _c(
                          "div",
                          { staticClass: "file-embed-header" },
                          [
                            _c("span", { staticClass: "file-embed-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbotv2.embeddingStatusCardLabel")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.resolveEmbedStatus(kb) === "failed" &&
                            kb.supsisEmbed &&
                            kb.supsisEmbed.error
                              ? _c(
                                  "a-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      title: kb.supsisEmbed.error,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          "file-embed-pill",
                                          "file-embed-pill--" +
                                            _vm.resolveEmbedStatus(kb),
                                        ],
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "file-embed-dot",
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.getEmbedPillText(kb)) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    class: [
                                      "file-embed-pill",
                                      "file-embed-pill--" +
                                        _vm.resolveEmbedStatus(kb),
                                    ],
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "file-embed-dot",
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.getEmbedPillText(kb)) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "file-body" }, [
                      _c("div", { staticClass: "file-icon-wrap" }, [
                        _c("div", { staticClass: "file-icon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(_vm.getFileIconType(kb))),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "file-name",
                          attrs: { title: _vm.getFileName(kb) },
                        },
                        [_vm._v(_vm._s(_vm.getFileName(kb)))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "file-actions" },
                      [
                        _vm.isSupsisRag
                          ? _c(
                              "a-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  title: _vm.$t("chatbotv2.reembedKnowledge"),
                                },
                              },
                              [
                                _c(
                                  "SupsisButton",
                                  {
                                    staticClass: "file-action-btn",
                                    attrs: {
                                      small: "",
                                      ghost: "",
                                      disabled:
                                        _vm.loading ||
                                        _vm.isKbEmbeddingBusy(kb),
                                    },
                                    on: {
                                      click: function (e) {
                                        return _vm.reembedFile(kb, e)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("model_training"),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              title: _vm.$t("message.delete"),
                            },
                          },
                          [
                            _c(
                              "SupsisButton",
                              {
                                staticClass: "file-action-btn",
                                attrs: {
                                  small: "",
                                  ghost: "",
                                  disabled: _vm.loading,
                                },
                                on: {
                                  click: function () {
                                    return _vm.deleteFile(kb)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("delete"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              title: _vm.$t("chatbotv2.openFile"),
                            },
                          },
                          [
                            _c(
                              "SupsisButton",
                              {
                                staticClass: "file-action-btn",
                                attrs: {
                                  small: "",
                                  ghost: "",
                                  disabled: _vm.loading,
                                },
                                on: {
                                  click: function () {
                                    return _vm.openFile(kb)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("open_in_new"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
          ])
        : _c("ComingSoon", {
            attrs: {
              "action-text": _vm.$t("chatbotv2.addFile"),
              "no-data-text": _vm.$t("chatbotv2.noFileAdded"),
              addContent: _vm.selectFile,
              disabled: false,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }